import React, { Component } from 'react'
import { i18n } from '../index'
import css from './BudgetPlanning.css'
type IndexDisplayProps = {
  label: string
  value: number | string
}

const IndexDisplay = ({ label, value }: IndexDisplayProps) => (
  <div className={css.indexDisplay}>
    <div className={css.indexLabel}>{label}</div>
    <div className={css.indexValue}>{value}</div>
  </div>
)

type Props = {
  label: string
  indexes: {
    salesIndex: number | string
    hoursIndex: number | string
    efficiencyFactor: number | string
  }
}
export default class IndexSection extends Component<Props> {
  render() {
    const { salesIndex, hoursIndex, efficiencyFactor } = this.props.indexes
    return (
      <div className={css.indexSectionContainer}>
        <div className={css.fieldLabel}>{this.props.label}</div>
        <div className={css.rowContainer}>
          <IndexDisplay label={i18n.t('budgetPlanning.sales')} value={salesIndex} />
          <IndexDisplay label={i18n.t('budgetPlanning.hours')} value={hoursIndex} />
          <IndexDisplay label={i18n.t('budgetPlanning.efficiency')} value={efficiencyFactor} />
        </div>
      </div>
    )
  }
}
